const refs = 'contacts'
export default [
    { 
        path: '/'+refs, 
        name: refs, 
        component: () => import('@/views/'+refs+'/List.vue')
    }
]
